import React from 'react';
import ReactDOM from 'react-dom/client';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { AuthProvider } from 'oidc-react';
import getConfig from './config/env.ts';
import { getOidcConfig } from './config/oidc.ts';

async function initialize() {
  try {
    // Wait for the configuration to be fetched
    const config = await getConfig();
    // Generate the OIDC config *after* fetching is complete
    const oidcConfig = getOidcConfig(config);

    // Get the root element and render the app *after* config is ready
    const rootElement = document.getElementById('root');
    if (!rootElement) {
      throw new Error('Root element #root not found');
    }
    createRoot(rootElement).render(
      // <StrictMode>
      <AuthProvider {...oidcConfig}>
        <App />
      </AuthProvider>,
      // </StrictMode>,
    );
  } catch (error) {
    // Log the error if fetching or config processing fails
    console.error('Failed to initialize application:', error);
    // Optionally render a minimal error message to the user
    const rootElement = document.getElementById('root');
    if (rootElement) {
      rootElement.innerHTML = 'Failed to load application configuration. Please check the console or contact support.';
    }
  }
}

// Run the initialization function
initialize();
